var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHelp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7A8E96",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 12a9.6 9.6 0 1 0-19.2 0M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12M2.4 12a9.6 9.6 0 1 0 19.2 0m2.4 0c0 6.627-5.373 12-12 12S0 18.627 0 12",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Aleo-Bold, Aleo",
    fontSize: 19,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8,
    y: 18
  }, "?")))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-help.24f8c3cbf4b24dd33f12c576cf534d70.svg";